export default __webpack_public_path__ + "static/media/routine.58091f38.svg";